import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { PeopleTwoIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createPcr } from '../../api/pcr/create-pcr'
import UserNavBar from '../../components/elements/nav-bar'
import PcrForm from '../../components/pages/pcr/pcr-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const PcrCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createPcr,
    onError: showAxiosError,
    onSuccess: () => toast.success('PCR créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un nouveau PCR'} icon={PeopleTwoIcon} />
      <div className="h-4" />
      <Box>
        <div className="flex justify-between items-center py-2">
          <div className="flex items-center gap-4">
            <Typography variant="sub-heading">
              Veuillez modifier le formulaire ci-dessous
            </Typography>
          </div>
        </div>
        <div className="h-5" />
        <PcrForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.PCR_UPDATE_PAGE.replace(':id', res.id.toString()), { replace: true })
            },
            onCancel: () => back(Paths.PCRS_PAGE)
          })}
        />
      </Box>
    </div>
  )
}

export default PcrCreatePage
